const TOOLTIP_VARIANTS = {
  DEFAULT: 'default-styled-tooltip',
  SIDEBAR_TOOLTIP: 'sidebar-styled-tooltip',
};

export { TOOLTIP_VARIANTS };
